import handler from '../handler'

const create = args => handler({ url: '/admin/call/create', method: 'post', args })
const update = args => handler({ url: '/admin/call/update', method: 'put', args })
const fetch = args => handler({ url: '/admin/call/fetch', method: 'get', args })
const fetchAll = args => handler({ url: '/admin/call/fetchAll', method: 'get', args })
const getStatistics = args => handler({ url: '/admin/call/statistics', method: 'get', args })
const deleteCall = args => handler({ url: '/admin/call/delete', method: 'delete', args })

export default {
  create,
  update,
  fetch,
  fetchAll,
  getStatistics,
  delete: deleteCall
}

